import { EAssetType } from "app/UtilitiesAndConstants/types/assetType";

export const isSegmentsLimitReached = (selectedDomains, maxSegmentsInCategory) => {
    let segmentCount = 0;

    selectedDomains.forEach((domain) => {
        if (domain.type === EAssetType.Segment) {
            segmentCount++;
        }
    });

    if (maxSegmentsInCategory <= segmentCount) {
        return true;
    }
    return false;
};
